export default "__VITE_ASSET__B$iIuXcZ__"